import React, { Component } from 'react';
import { history } from '../../redux/store';
//import { useHistory } from 'react-router';
import { useEffect, useState } from 'react';
import moment from 'moment';
import axios from "axios";
import { Spin, Row, Col, Divider } from 'antd';
import { Button, Form, Input, Switch, Space } from 'antd';
import { LoginOutlined } from '@ant-design/icons/lib';
import setting from '../../config/setting';
import PublicLayout from '../../layout/public/Public';
import { Link } from 'react-router-dom';
import { useForm } from 'antd/es/form/Form';
import { navigateHome } from '../../utils/naviagate-home';
import { navigateEmployeeHome } from '../../utils/navigate-employee-home';



import {
  ExperimentOutlined,
  EyeInvisibleOutlined, EyeTwoTone,
  MonitorOutlined,
  UserAddOutlined,
  UserOutlined,
  MedicineBoxOutlined,
  CalendarOutlined,
  CheckSquareOutlined
} from '@ant-design/icons/lib';



const { Item } = Form;



const EmployeeSignIn = () => {

  const [name, setName] = useState('digitalglyde.com');
  const [otp, setOtp] = useState('');
  


  
  // let history=useHistory();



  function userName(event) {
    console.log("event name", event.target.value);
    setName(event.target.value);
  }

  // function password(event) {
  //   console.log("event pass", event.target.value);
  //   setPass(event.target.value);
  // }



  const [form] = useForm();

  function generateOtp(){
    var digits = '0123456789';
      let OTP = '';
      for (let i = 0; i < 4; i++ ) {
          OTP += digits[Math.floor(Math.random() * 10)];
      }
      return OTP;
  }
  
  


  function login() {

    console.log(name);
    setName(name);
    //console.log(name);
    let result=/^\w{2,}@\w{2,}\.\w{2,4}$/.test(name) || /^[7-9][0-9]{9}$/.test(name);
    //console.log(result);
    if(result){
      //Send otp as props to next page
      history.push("/public/Enter-Otp");
    }
    else{history.push("/public/EmployeeSign-in");
  
    }
    
  }



  return (

    <Row style={{
      height:'100%',
      backgroundImage: `url(${"covid_background.png"})`,
      backgroundSize: 'cover', backgroundPosition: '57% 50%', position: 'relative'
    }}>
      <Col span={7} style={{ height: '100%' }}>
        <div>

          <PublicLayout
          // bgImg={require('./wss.png')} 
          >
            <h4 className='mt-0 mb-1'>WSS Login</h4>

            <p
              style={{ color: '#161717' }}
            //className='text-color-200'
            >Login to access your Employee Account</p>

            <Form form={form} layout='vertical' className='mb-4'>
              <Item name='login' rules={[{ required: true, message: <></> }]}>
                <Input placeholder='Email/Phone Number' onChange={userName} />
              </Item>

              {/* <Item name='password' rules={[{ required: true, message: <></> }]}>
                <Input placeholder='Password' type='password' onChange={password}
                />
              </Item>

              <div className='d-flex align-items-center mb-4'>
                <Switch defaultChecked /> <span className='ml-2'>Remember me</span>
              </div> */}

              <Button
                block={false}
                type='primary'
                onClick={login}
                htmlType='submit'
                icon={<LoginOutlined style={{ fontSize: '1.3rem' }} />}
              >
                Login
        </Button>
            </Form>
            <br />
            {/* <p className='mb-1'>
              <a href='#'>Forgot password?</a>
            </p>

            <p>
              Don't have an account? <Link to='sign-up'>Sign up!</Link>
            </p> */}
          </PublicLayout>
        </div>
      </Col>
      <Col span={17}


      //style={{}}
      >
        <h3 style={{ textAlign: 'center', color: 'white', position: 'absolute', top: '40%', left: '20%' }}>COVID-19 Testing & Vaccines</h3>
        {/* <img src={require('./wss.png')} style={{width:'100%',height:'fit-content'}} /> */}

      </Col>
    </Row>
  );
  // }
};

export default EmployeeSignIn;
